import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraLink } from '../ensigns/link';
import { SpecraText } from '../ensigns/typography';
/** A reference (requirement id), its text and its status in one row. */ export function SpecraReferenceRow({ reference, label, status, href, renderLink, className, ...props }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex items-start gap-[var(--space-2-5)] border-b border-border/70 py-[var(--space-2)]', className),
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraText, {
                className: "shrink-0 whitespace-nowrap font-medium",
                size: "body-ui",
                children: href ? /*#__PURE__*/ _jsx(SpecraLink, {
                    href: href,
                    renderLink: renderLink,
                    children: reference
                }) : reference
            }),
            /*#__PURE__*/ _jsx(SpecraText, {
                as: "div",
                className: "min-w-0 flex-1",
                size: "body-ui",
                children: label
            }),
            status ? /*#__PURE__*/ _jsx("span", {
                className: "shrink-0",
                children: status
            }) : null
        ]
    });
}
